import { render, staticRenderFns } from "./FireRiskDashboard.page.vue?vue&type=template&id=ec917706&scoped=true"
import script from "./FireRiskDashboard.page.vue?vue&type=script&setup=true&lang=ts"
export * from "./FireRiskDashboard.page.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FireRiskDashboard.page.vue?vue&type=style&index=0&id=ec917706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec917706",
  null
  
)

export default component.exports